module.exports = __webpack_public_path__ + "media/application/images/ui/logo-consumer-trusted-8949f35301903e2be7e945bf24e3911d.png";